// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"H_thecomp__XeAIz"};